<template>
    <div class="image" v:bind="$attrs" v-if="user.first_name || userHasPicture">
        <b-img-lazy
            v-if="userHasPicture"
            :src="imgSrc"
            :width="imgWidth"
            :class="{ 'rounded-circle d-block': !imgSquare }"
            :alt="user.full_name"
        />

        <initials-img
            v-else
            :letters="userInitials"
            :full-string="user.full_name"
            :img-width="imgWidth"
            :img-square="imgSquare"
        />
    </div>
</template>

<script>
import InitialsImg from '@/components/helpers/InitialsImage.vue';
export default {
    components: {
        InitialsImg
    },

    props: ['user', 'size', 'imgWidth', 'imgSquare'],

    computed: {
        userHasPicture() {
            return !_.isEmpty(this.user.picture);
        },

        userInitials() {
            return this.user.first_name.charAt(0) + this.user.last_name.charAt(0);
        },

        imgSrc() {
            if (this.userHasPicture) {
                switch (this.size) {
                    case 'large':
                        return this.user.picture['url_512x512'];
                    case 'medium':
                        return this.user.picture['url_256x256'];
                    default:
                        return this.user.picture['url_128x128'];
                }
            }
            return '';
        }
    }
};
</script>
